import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type {
  UpdateUserGroupRequestBody,
  UpdateUserGroupResponseBody,
  UpdateUserGroupRequestParams,
} from './types';

export const useUpdateGroupMutation: MutationFunction<
  UpdateUserGroupResponseBody,
  UpdateUserGroupRequestBody,
  [UpdateUserGroupRequestParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { locator } = params;
  const urlPath = `/users/groups/${locator}/`;
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: (requestData) => {
      return request<UpdateUserGroupResponseBody>(urlPath, {
        init: {
          method: 'PATCH',
          body: requestData,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['groupDetail'],
  });
};
